import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Login from "./component/login";
import UserManagement from "./component/userManagement";
import ChangePassword from "./component/changePassword";
import Home from "./component/Home";
import { useState, useEffect } from "react";
import { AuthTokenContext, userDataContext } from "./context/tokenContext";
function App() {
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [userData, setUserData] = useState({ userStatus: "", userEmail: "" });
  // useEffect(() => {
  //   console.log("here");
  //   setToken(localStorage.getItem("token"));
  // }, [token]);

  const router = createBrowserRouter([
    {
      path: "/",
      element: <Login />,
    },
    {
      path: "home",
      element: <Home />,
      children: [
        { path: "userManagement", element: <UserManagement /> },
        { path: "changePassword", element: <ChangePassword /> },
      ],
    },
  ]);
  return (
    <AuthTokenContext.Provider value={[token, setToken]}>
      <userDataContext.Provider value={[userData, setUserData]}>
        <RouterProvider router={router}></RouterProvider>
      </userDataContext.Provider>
    </AuthTokenContext.Provider>
  );
}

export default App;
